export enum ESignicatVerificationActions {
  Verify = 'SignicatVerify',
  Verified = 'SignicatVerified',
  Failed = 'SignicatFailed'
}
